export const selectModalDetails = state => state.modalReducer || {};
